module.exports = function (app) {
    'use strict';
    app.directive('cardImgError', function ($timeout) {
        return {
            scope: {
                imgObj: '=cardImgError'
            },
            link: function(scope, element, attrs) {
                element.on('error',function(){
                    $timeout(function(){
                        scope.imgObj.error=true;
                        scope.imgObj.imageLoaded=true;
                    },200);

                });

                element.on('load', function() {
                    $timeout(function(){
                        scope.imgObj.imageLoaded=true;
                    },200);
                });

            }
        };
    });
};

